import { render, staticRenderFns } from "./VatRateCreate.vue?vue&type=template&id=26b029de&"
import script from "./VatRateCreate.vue?vue&type=script&lang=ts&"
export * from "./VatRateCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports